const sections = { agenda: "agenda", bookings: "pendings", customers: "clients", services: "services", team: "workers", reports: "analytics", finance: "finance", inventory: "inventory", settings: "settings", loyalty: "loyalty", memberships: "memberships" };
export function readCalendarSection(search) {
  const query = new URLSearchParams(search);
  const key = query.get("section");
  const tab = Object.prototype.hasOwnProperty.call(sections, key) ? sections[key] : "agenda";
  const report = ["overview", "memberships", "inventory", "finance", "crm", "exports", "traffic", "insights"].includes(query.get("report")) ? query.get("report") : "overview";
  return { tab, report };
}
export function calendarSectionSearch(search, tab, report = "overview") {
  const query = new URLSearchParams(search);
  const section = Object.keys(sections).find(key => sections[key] === tab) || "agenda";
  if (section === "agenda") query.delete("section"); else query.set("section", section);
  if (section === "reports" && report !== "overview") query.set("report", report); else query.delete("report");
  return query.toString() ? `?${query}` : "";
}

export function permittedCalendarSection(search, allowedTabs, workerScope = false) {
  const route = readCalendarSection(search);
  const restricted = workerScope && ['workers','analytics','clients','services','settings'].includes(route.tab);
  return {...route, tab: !restricted && allowedTabs.includes(route.tab) ? route.tab : 'agenda'};
}
